import { Component } from 'react';
import { GenericValue } from '../types';
import OldInput from './OldInput';

export class LiveAgent extends Component<
  Record<string, never>,
  { value: GenericValue; }
> {
  state = {
    value: window.apm.serialized.dtmf_live_agent_override_pattern || ''
  };

  setConfig(_: any | null, value: GenericValue) {
    this.setState({ value });
    window.apm.serialized.dtmf_live_agent_override_pattern = value as string;
    window.apm.serialized.dtmf_live_agent_override_patternLastLocalChange =
      window.apm.timestamp;
    window.apm.setSerializedChanged();
  }

  getConfig() {
    return window.apm.serialized.dtmf_live_agent_override_pattern;
  }

  render() {
    return (
      <div className="container-fluid element-dialog">
        <div className="row">
          <div className="row">
            <div className="col-md-4">
              <OldInput
                context={this as any}
                valRules={{ dtmfOverride: true }}
                label={window.l.settings.dtmf_live_agent_override_pattern}
                hint={window.l.settings.dtmf_live_agent_override_placeholder}
                valKey="dtmfLiveAgent"
                tooltip={window.l.settings.dtmf_live_agent_override_tooltip}
                value={this.state.value}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}
